import React, { useEffect } from "react";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import Modal from "../../modules/layout/Modal";
import Select from "../../atoms/input/Select";
import { isQuestionModifyModalOpenState } from "../../../recoil/admin/examRoom";
import AdminQuestionSelect from "./AdminQuestionSelect";
import AdminQuestionTable from "./AdminQuestionTable";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useQuestionActions from "../../../api/hooks/admin/question";
import {
  firstQuestionState,
  secondQuestionState,
  selectedComboSnState,
  selectorState,
  thirdQuestionState,
} from "../../../recoil/admin/question";

const AdminQuestionModifyModal = () => {
  const [isQuestionModifyModalOpen, setIsQuestionModifyModalOpen] =
    useRecoilState(isQuestionModifyModalOpenState);

  const { fetchCombo, modifyCombo } = useQuestionActions();

  const [firstQuestion, setFirstQuestion] = useRecoilState(firstQuestionState);
  const [secondQuestion, setSecondQuestion] =
    useRecoilState(secondQuestionState);
  const [thirdQuestion, setThirdQuestion] = useRecoilState(thirdQuestionState);

  const [selectedValue, setSelectedValue] = useRecoilState(selectorState);

  const resetFirstQuestion = useResetRecoilState(firstQuestionState);
  const resetSecondQuestion = useResetRecoilState(secondQuestionState);
  const resetThirdQuestion = useResetRecoilState(thirdQuestionState);
  const resetSelectedValues = useResetRecoilState(selectorState);
  const comboSn = useRecoilValue(selectedComboSnState);

  const queryClient = useQueryClient();

  const mutation = useMutation(modifyCombo, {
    onSuccess: (context) => {
      resetFirstQuestion();
      resetSecondQuestion();
      resetThirdQuestion();
      setIsQuestionModifyModalOpen(false);
      queryClient.invalidateQueries("fetchCombo");
    },
    onError: () => {},
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    var returnConfirm = window.confirm(
      "문항 수정 시 기존에 응시자에게 출제된 문항 정보도 일괄적으로 변경되며, 이로 인해 응시자가 제출한 답변 내용과 매칭이 되지 않을 수 있습니다. 문항 수정을 진행하시겠습니까?"
    );
    if (returnConfirm === true) {
      const req = {
        combo: { ...selectedValue, sn: comboSn },
        question: [firstQuestion, secondQuestion, thirdQuestion],
      };

      mutation.mutate(req);
    }
  };

  return (
    <>
      <Modal isOpen={isQuestionModifyModalOpen}>
        <div className="modal fade" id="url" style={{ display: "block" }}>
          <div className="modal-content" style={{ width: "1540px" }}>
            <div className="modal-header flex">
              <div className="modal-title">
                <p>콤보</p>
              </div>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>콤보수정</p>
              </div>
              <form onSubmit={handleSubmit}>
                <AdminQuestionSelect />
                <AdminQuestionTable />
                <div className="modal-footer text-align-right">
                  <button
                    type="button"
                    className="modal-btn modal-close-btn"
                    onClick={() => {
                      resetFirstQuestion();
                      resetSecondQuestion();
                      resetThirdQuestion();
                      resetSelectedValues();
                      setIsQuestionModifyModalOpen(false);
                    }}
                  >
                    닫기
                  </button>
                  <button type="submit" className="modal-btn modal-save-btn">
                    완료
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdminQuestionModifyModal;
